module.exports = __webpack_public_path__ + "img/shooting_03.8d552d51.jpg";